import { LanguageType } from './enum.model';
export class SearchStreet{
    streetName: string;
    languageType: LanguageType;
}